import { render, staticRenderFns } from "./PosTableDetailALaCarte.vue?vue&type=template&id=3a4d9992&scoped=true"
import script from "./PosTableDetailALaCarte.vue?vue&type=script&lang=js"
export * from "./PosTableDetailALaCarte.vue?vue&type=script&lang=js"
import style0 from "./PosTableDetailALaCarte.vue?vue&type=style&index=0&id=3a4d9992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d9992",
  null
  
)

export default component.exports